import PropTypes from "prop-types";
import React from "react";
import { HashButton, LinkButton } from "./button.style";

const Button = ({ children, path, ...rest }) => {
    const internal = /^\/(?!\/)/.test(path);
    const isHash = path.startsWith("#");

    if (internal) {
        return (
            <LinkButton to={path} {...rest}>
                {children}
            </LinkButton>
        );
    } else if (isHash) {
        return (
            <HashButton href={path} {...rest}>
                {children}
            </HashButton>
        );
    }
};

Button.propTypes = {
    children: PropTypes.node,
    path: PropTypes.string,
};

export default Button;
